import React from 'react';
import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import { EConnectionStatuses } from '@enums/common';

import { CONNECTION_LOGS_FIELD_NAMES, CONNECTION_LOGS_LABELS } from '../constants';

import styles from '../ManageMiddlewareSMO.module.scss';

const columnHelper = createColumnHelper<any>();

export const getColumns = (): ColumnDef<any>[] => [
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.systemId, {
		header: CONNECTION_LOGS_LABELS.id,
		cell: ({ getValue }: CellContext<any, any>) => {
			const systemId = getValue();

			return <AdaptiveTableCell text={systemId} />;
		},
	}),
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.eventType, {
		header: CONNECTION_LOGS_LABELS.eventType,
		cell: ({ getValue }: CellContext<any, any>) => {
			const eventType = getValue();

			return <AdaptiveTableCell text={eventType.title} />;
		},
	}),
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.connectionStatus, {
		header: CONNECTION_LOGS_LABELS.connectionStatus,
		cell: ({ getValue }: CellContext<any, any>) => {
			const connectionStatus = getValue();

			const className = connectionStatus.name === EConnectionStatuses.CONNECTED
				? styles.online
				: connectionStatus.name === EConnectionStatuses.DISCONNECTED
					? styles.offline
					: undefined;

			return (
				<AdaptiveTableCell
					className={className}
					text={connectionStatus.title}
				/>
			);
		},
	}),
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.createdAtText, {
		header: CONNECTION_LOGS_LABELS.dateTime,
		cell: ({ getValue }: CellContext<any, any>) => {
			const createdAt = getValue();

			return <AdaptiveTableCell text={createdAt} />;
		},
	}),
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.source, {
		header: CONNECTION_LOGS_LABELS.source,
		cell: ({ getValue }: CellContext<any, any>) => {
			const source = getValue();

			return <AdaptiveTableCell text={source.title} />;
		},
	}),
	columnHelper.accessor(CONNECTION_LOGS_FIELD_NAMES.userName, {
		header: CONNECTION_LOGS_LABELS.user,
		cell: ({ getValue }: CellContext<any, any>) => {
			const userName = getValue();

			return <AdaptiveTableCell text={userName || '-'} />;
		},
	}),
];
